/**
 * Mobile-friendly tables, app-wide.
 *
 * On small screens (see `table.stack` rules in index.css) each table row is
 * shown as a card, every cell prefixed by its column name. This keeps the
 * column names in sync by copying each header's text into the cells'
 * `data-label`, for every table rendered now or later.
 * Opt out with the `no-stack` class (e.g. the printable document preview).
 */
const labelTable = (table) => {
    if (table.classList.contains('no-stack')) return;
    table.classList.add('stack');
    const headerRow = table.tHead?.rows[table.tHead.rows.length - 1];
    if (!headerRow) return;
    const labels = Array.from(headerRow.cells, (th) => th.innerText.replace(/[↑↓]/g, '').trim());
    const blank = (cell) => ['', '-', '—'].includes(cell.innerText.trim());
    Array.from(table.tBodies).forEach((body) => {
        Array.from(body.rows).forEach((row) => {
            let col = 0;
            const cells = Array.from(row.cells);
            cells.forEach((cell) => {
                const label = labels[col] || '';
                if (cell.getAttribute('data-label') !== label) cell.setAttribute('data-label', label);
                col += cell.colSpan || 1;
            });
            // Card title: the first cell with content (an empty "-" id column is hidden)
            const titleIndex = Math.max(0, cells.findIndex((c) => !blank(c)));
            cells.forEach((cell, i) => {
                cell.classList.toggle('stack-title', i === titleIndex);
                cell.classList.toggle('stack-hidden', i < titleIndex);
            });
        });
    });
};

export const installResponsiveTables = () => {
    let scheduled = false;
    const run = () => {
        scheduled = false;
        document.querySelectorAll('table').forEach(labelTable);
    };
    const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(run);
    };
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
};
